import 'regenerator-runtime/runtime'
import axios from 'axios';
import router from './router';
import VueCookie from './helpers/cookies.js';
import VueSocketIO from 'vue-3-socket.io';
import SocketIO from 'socket.io-client'
import VueMobileDetection from "vue-mobile-detection";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import { fpjsPlugin } from '@fingerprintjs/fingerprintjs-pro-vue-v3';
import { useToast } from 'vue-toastification'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import mitt from 'mitt'
import { useUserStore } from './stores/User'
import '@vuepic/vue-datepicker/dist/main.css'
import App from "./components/App.vue";

const pinia = createPinia();
const app = createApp(App);
const emitter = mitt();
import '../src/styles/main.css'

app.use(pinia)

const userStore = useUserStore();
const API_URL = window.location.hostname === 'localhost' ? import.meta.env.VITE_API_URL : `${window.location.protocol}//${window.location.hostname}`;


axios.defaults.baseURL = API_URL;
axios.defaults.headers.common['Content-Type'] = 'application/json';

app.use(VueCookie);
app.use(VueMobileDetection);

app.config.globalProperties.axios = axios
app.config.globalProperties.$hostname = API_URL;

app.config.globalProperties.$company = {
    project: 'AVOCADO',
    name: 'Avocado N. V.',
    license: '163462',
    number: '163462',
    address: 'Zuikertuintjeweg Z/N (Zuikertuin Tower)',
    city: 'Curaçao',
    email: 'avocado.casino@gmail.com',
    issued_by: 'Gaming Services Provider N.V.'
};
app.config.globalProperties.$refhost = import.meta.env.VITE_REFERRER_URL;
app.config.globalProperties.$link = {
    vk: import.meta.env.VITE_VK_URL,
    support: import.meta.env.VITE_SUPPORT_URL,
    tg: import.meta.env.VITE_TG_CHANNEL_URL,
    reviews: import.meta.env.VITE_REVIEWS_URL,
    manager: import.meta.env.VITE_MANAGER_URL,
    manager_username: import.meta.env.VITE_MANAGER_DISPLAY_URL,
};
app.config.globalProperties.$slotegrator = {
    slots: 1,
    live: 2
};
app.config.globalProperties.$reCaptchaSiteKey = '6LeJPnAoAAAAAPJeKr205xphhI7u0wl9mFeE8hsW';

const wsHost = import.meta.env.VITE_WS_HOST;

const wsInstance = SocketIO(wsHost, {
    transports: ["websocket", "polling"],
    rememberUpgrade: true,
    path: '/'
});
app.use(new VueSocketIO({
    // debug: true,
    connection: wsInstance
}))

app.use(router);

app.use(fpjsPlugin, {
    loadOptions: {
        apiKey: "m1H1AJpIJNxXuRliJ7bQ",
        scriptUrlPattern: `${API_URL}/0xQg2KsEBWCo79Ur/qxRQEH3WMMkH9ZvM?apiKey=<apiKey>&version=<version>&loaderVersion=<loaderVersion>`,
        region: "eu",
        endpoint: `${API_URL}/0xQg2KsEBWCo79Ur/x2Vjl3eA3iIMKJzx?region=eu`
    },
});

const toastOptions = {
    position: "bottom-right",
    timeout: 5000,
    closeOnClick: true,
    pauseOnFocusLoss: true,
    pauseOnHover: true,
    draggable: true,
    draggablePercent: 0.6,
    transition: "Vue-Toastification__slideBlurred",
    maxToasts: 2,
    newestOnTop: true,
    shareAppContext: true
};

app.use(Toast, toastOptions);

app.config.globalProperties.$toast = useToast();
app.config.globalProperties.emitter = emitter;

app.config.globalProperties.$launcher = window.sg;

app.mount('#app');